import { jsxs, jsx } from "react/jsx-runtime";
import { styled } from "@linaria/react";
import * as React from "react";
import { elevationClassName, typographyClassName } from "@creditornot/cb-ingredients";
import { createCssVars, assignInlineCssVars, clsx } from "@creditornot/cb-utils";
import "./style.css";
const cssVars = createCssVars(["height", "focusIndicatorWidth", "knobSize"]);
const BG = /* @__PURE__ */ styled("div")({
  name: "BG",
  class: "cb_InputSwitch_BG_b1ky",
  propsAsIs: false
});
const Knob = /* @__PURE__ */ styled("div")({
  name: "Knob",
  class: "cb_InputSwitch_Knob_k13r",
  propsAsIs: false
});
const Root$1 = /* @__PURE__ */ styled("div")({
  name: "Root",
  class: "cb_InputSwitch_Root_r1hw",
  propsAsIs: false
});
const Input = /* @__PURE__ */ styled("input")({
  name: "Input",
  class: "cb_InputSwitch_Input_ivt1",
  propsAsIs: false
});
const InputSwitch = React.forwardRef(({
  checked,
  className,
  disabled = false,
  inputClassName,
  inputStyle,
  name,
  rootRef,
  style,
  styleParams,
  ...rest
}, ref) => /* @__PURE__ */ jsxs(Root$1, {
  "aria-disabled": disabled,
  className,
  ref: rootRef,
  style: {
    ...(styleParams ? assignInlineCssVars(cssVars, styleParams) : null),
    ...style
  },
  children: [/* @__PURE__ */ jsx(Input, {
    ...rest,
    checked,
    className: inputClassName,
    disabled,
    name,
    ref,
    style: inputStyle,
    type: "checkbox"
  }), /* @__PURE__ */ jsx(BG, {}), /* @__PURE__ */ jsx(Knob, {
    className: clsx(!disabled && elevationClassName.small)
  })]
}));
InputSwitch.displayName = "InputSwitch";
const InputSwitch$1 = InputSwitch;
const Root = /* @__PURE__ */ styled("div")({
  name: "Root",
  class: "cb_Switch_Root_r18g",
  propsAsIs: false
});
const TextLabel = /* @__PURE__ */ styled("span")({
  name: "TextLabel",
  class: "cb_Switch_TextLabel_t1m3",
  propsAsIs: false
});
const Label = /* @__PURE__ */ styled("label")({
  name: "Label",
  class: "cb_Switch_Label_l15b",
  propsAsIs: false
});
const Switch = React.forwardRef(({
  checked,
  children,
  className,
  disabled,
  inputProps,
  labelPosition = "end",
  name,
  onBlur,
  onChange,
  onClick,
  onFocus,
  readOnly,
  required,
  rootRef,
  style,
  value
}, ref) => /* @__PURE__ */ jsx(Root, {
  "aria-disabled": disabled,
  className,
  ref: rootRef,
  style,
  children: /* @__PURE__ */ jsxs(Label, {
    "aria-disabled": disabled ? true : void 0,
    "data-label-position": labelPosition === "start" ? "start" : void 0,
    children: [/* @__PURE__ */ jsx(InputSwitch$1, {
      ...inputProps,
      checked,
      disabled,
      name,
      onBlur,
      onChange,
      onClick,
      onFocus,
      readOnly,
      ref,
      required,
      value
    }), typeof children === "string" ? /* @__PURE__ */ jsx(TextLabel, {
      className: typographyClassName.Body3,
      children
    }) : /* @__PURE__ */ jsx("span", {
      children
    })]
  })
}));
Switch.displayName = "Switch";
const Switch$1 = Switch;
export {
  InputSwitch$1 as InputSwitch,
  Switch$1 as Switch
};
//# sourceMappingURL=index.js.map
